function isDefined(value) {
	return value !== undefined;
}

module.exports = isDefined;
